/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FaceDto } from "./FaceDto";
import { FaceConfigurationSectionFragmentCombinationDto } from "./FaceConfigurationSectionFragmentCombinationDto";
import { AreaFragmentCombinationDeclarationGroupDto } from "./AreaFragmentCombinationDeclarationGroupDto";

export class FaceConfigurationDto {
    id: string;
    width: number | null;
    height: number | null;
    depth: number | null;
    angle: number;
    configurationTemplateId: string;
    organisationId: string | null;
    faces: FaceDto[];
    sectionFragmentCombinations: FaceConfigurationSectionFragmentCombinationDto[];
    areaFragmentCombinationDeclarationGroups: AreaFragmentCombinationDeclarationGroupDto[];
}
